import React from 'react';
import { matchPath } from 'react-router-dom';
import UniversalPlayer from 'components/shared/UniversalPlayer';

const isPreviewing = !!matchPath(window.location.pathname, {
  path: '/preview/',
});

const SeismicContent = ({
  content_id: id,
  library_content_id: contentId,
  universal_link: universalLink,
}) => {
  if (isPreviewing && !contentId) return null;

  return <UniversalPlayer id={id} universalLink={universalLink} />;
};

export default SeismicContent;
